export const VERIFY_FILTER_HISTORY = 'VERIFY_FILTER_HISTORY'
export const VERIFY_FILTER_HISTORY_ERR = 'VERIFY_FILTER_HISTORY_ERR'
export const RESET_VERIFY_FILTER_HISTORY = 'RESET_VERIFY_FILTER_HISTORY'